/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum EmotionType {
  None = 'None',
  Depressed = 'Depressed',
  Lonely = 'Lonely',
  Sad = 'Sad',
  Angry = 'Angry',
  Frustrated = 'Frustrated',
  Anxious = 'Anxious',
  Stressed = 'Stressed',
  Tired = 'Tired',
  Confused = 'Confused',
  Calm = 'Calm',
  Content = 'Content',
  Happy = 'Happy',
  Loved = 'Loved',
  Excited = 'Excited',
  WcVeryUnhappy = 'WC_VeryUnhappy',
  WcNotSoGood = 'WC_NotSoGood',
  WcOkay = 'WC_Okay',
  WcHappy = 'WC_Happy',
  WcFantastic = 'WC_Fantastic'
}
